import DemoRoullete from './DemoRoullete';

customElements.define('demo-roulette', DemoRoullete);
